module.exports = __webpack_public_path__ + "static/media/pressure-monitor-action-alert.fe2b2ba4.svg";